import type { SVGProps } from 'react';
const SvgChannelsSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      fillOpacity={0.88}
      d="M10.297 6.533h4.59a.255.255 0 0 0 .256-.255V1.685a.255.255 0 0 0-.255-.255h-4.591a.255.255 0 0 0-.256.255v1.659H7.618a.127.127 0 0 0-.127.127v3.955h-1.53V5.703a.255.255 0 0 0-.255-.255H1.113a.255.255 0 0 0-.256.255v4.593c0 .14.115.255.256.255h4.59a.255.255 0 0 0 .256-.255V8.573h1.53v3.955c0 .07.058.127.127.127h2.424v1.659c0 .14.114.255.255.255h4.591a.255.255 0 0 0 .255-.255v-4.59a.255.255 0 0 0-.255-.255h-4.59a.255.255 0 0 0-.255.255v1.786H8.638V4.492h1.403v1.786c0 .141.115.255.256.255m.955-3.89h2.679v2.68h-2.679zM4.748 9.34H2.07V6.662h2.678zm6.504 1.342h2.679v2.68h-2.679z"
    />
  </svg>
);
export default SvgChannelsSidebar;
